/*
 * ---------------------------------------------------------------------------
 * Precio sin impuestos — carrito y checkout
 *
 * Adjunta a cada línea del carrito una propiedad con el precio unitario
 * descontado el impuesto. El tema ya renderiza las propiedades en el drawer y
 * en la página de carrito (`cart-products.liquid`), Shopify las muestra nativas
 * en el checkout, y quedan en la orden. Una sola propiedad cubre las tres
 * superficies sin tocar el checkout, que no es parte del tema.
 *
 * En la ficha de producto esto NO interviene: ahí lo muestra el bloque, con
 * Liquid del lado del servidor.
 *
 * Se activa desde Configuración del tema → Precio sin impuestos. Está apagado
 * por defecto, así que en una tienda que no lo necesite este archivo no hace
 * absolutamente nada.
 *
 * Dos caminos para que un ítem quede con su propiedad:
 *
 *   1. Al agregar, si la ficha publicó el mapa de variantes (bloque presente),
 *      se toma de ahí el valor ya formateado por Liquid.
 *
 *   2. Si no hay mapa —quick add desde una tarjeta de colección, por ejemplo—
 *      se corrige después del alta: se lee el carrito, se calcula sobre el
 *      precio real de la línea y se completa la propiedad que falte.
 *
 * El camino 2 corre SOLO después de un alta, nunca en cada render del carrito.
 * Reconciliar en cada render obliga a mutar el carrito mientras el tema lo está
 * dibujando, y eso puede entrar en bucle.
 * ---------------------------------------------------------------------------
 */
(function () {
  var CFG = window.IronsideSinImpuestos;
  if (!CFG || !CFG.enabled) return;
  if (window.__IRONSIDE_SIN_IMP__) return;
  window.__IRONSIDE_SIN_IMP__ = true;

  var PROP = CFG.leyenda || 'Precio unit. sin imp. nacionales:';
  var DIVISOR = 1 + Number(CFG.tasa || 21) / 100;
  var SELECTOR = '[data-ironside-sin-imp-ar]';

  /* -------------------------------------------------------------- formato */

  // Réplica del formateo de `money_format` de Shopify. Existe solo para el
  // camino 2, donde el monto se calcula en el navegador y no hay Liquid que lo
  // arme. En la ficha y en el camino 1 el formato viene del servidor.
  function formatearMoneda(centavos) {
    var formato = CFG.money_format || '${{amount}}';

    function partir(numero, decimales, milesSep, decimalSep) {
      if (isNaN(numero)) return '0';
      var n = (numero / 100).toFixed(decimales);
      var partes = n.split('.');
      var entero = partes[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + milesSep);
      return partes[1] ? entero + decimalSep + partes[1] : entero;
    }

    return formato.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, token) {
      switch (token) {
        case 'amount':
          return partir(centavos, 2, ',', '.');
        case 'amount_no_decimals':
          return partir(centavos, 0, ',', '.');
        case 'amount_with_comma_separator':
          return partir(centavos, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return partir(centavos, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return partir(centavos, 2, "'", '.');
        case 'amount_with_space_separator':
          return partir(centavos, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator':
          return partir(centavos, 0, ' ', ',');
        case 'amount_with_period_and_space_separator':
          return partir(centavos, 2, ' ', '.');
        default:
          return partir(centavos, 2, ',', '.');
      }
    });
  }

  // Mismo redondeo que el snippet Liquid: a la unidad entera, para no mostrar
  // centavos que el precio de al lado no muestra.
  function sinImpuestos(centavos) {
    return Math.round(centavos / DIVISOR / 100) * 100;
  }

  /* ------------------------------------------------ camino 1: al agregar */

  function delMapa(id) {
    var lista = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < lista.length; i++) {
      var el = lista[i].querySelector('[data-ironside-sin-imp-ar-json]');
      if (!el) continue;
      try {
        var mapa = JSON.parse(el.textContent.trim() || '{}');
        if (mapa && mapa[id]) return mapa[id];
      } catch (e) {
        /* mapa ilegible: se sigue sin él */
      }
    }
    return null;
  }

  function conPropiedad(cuerpo) {
    if (cuerpo && cuerpo.id && !cuerpo.items) {
      var v = delMapa(String(cuerpo.id));
      if (v) {
        cuerpo.properties = cuerpo.properties || {};
        if (!cuerpo.properties[PROP]) cuerpo.properties[PROP] = v;
      }
    } else if (cuerpo && Array.isArray(cuerpo.items)) {
      cuerpo.items.forEach(function (it) {
        if (!it || !it.id) return;
        var val = delMapa(String(it.id));
        if (!val) return;
        it.properties = it.properties || {};
        if (!it.properties[PROP]) it.properties[PROP] = val;
      });
    }
    return cuerpo;
  }

  /* ------------------------------- camino 2: completar lo que quedó sin */

  var reconciliando = false;

  function completarFaltantes() {
    if (reconciliando) return;
    reconciliando = true;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (carrito) {
        var pendientes = (carrito.items || [])
          .map(function (item, i) {
            return { item: item, linea: i + 1 };
          })
          .filter(function (x) {
            var props = x.item.properties || {};
            if (props[PROP]) return false;
            // `final_price` es el unitario ya con descuentos aplicados.
            return x.item.final_price > 0;
          });

        // De a una, en cadena: cambiar una línea reescribe el carrito entero,
        // así que mandarlas en paralelo hace que se pisen entre sí.
        return pendientes.reduce(function (cadena, x) {
          return cadena.then(function () {
            var props = Object.assign({}, x.item.properties || {});
            props[PROP] = formatearMoneda(sinImpuestos(x.item.final_price));
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ line: x.linea, properties: props }),
            });
          });
        }, Promise.resolve());
      })
      .catch(function () {
        /* si falla, el ítem queda sin la leyenda: molesto, no roto */
      })
      .then(function () {
        reconciliando = false;
      });
  }

  /* --------------------------------------------------------- intercepción */

  function interceptar() {
    if (typeof window.fetch !== 'function') return;
    var original = window.fetch;

    window.fetch = function (entrada, init) {
      var esAlta = false;

      try {
        var url = typeof entrada === 'string' ? entrada : entrada && entrada.url ? entrada.url : '';
        esAlta = !!url && url.indexOf('/cart/add') > -1;

        if (esAlta && init && init.body) {
          var b = init.body;
          var clave = 'properties[' + PROP + ']';

          if (typeof FormData !== 'undefined' && b instanceof FormData) {
            var idF = b.get('id');
            if (idF && !b.has(clave)) {
              var vF = delMapa(String(idF));
              if (vF) b.append(clave, vF);
            }
          } else if (typeof URLSearchParams !== 'undefined' && b instanceof URLSearchParams) {
            var idU = b.get('id');
            if (idU && !b.has(clave)) {
              var vU = delMapa(String(idU));
              if (vU) b.append(clave, vU);
            }
          } else if (typeof b === 'string') {
            init.body = JSON.stringify(conPropiedad(JSON.parse(b)));
          }
        }
      } catch (e) {
        /* se sigue con el request original: romper el alta sería mucho peor */
      }

      var p = original.apply(this, arguments);

      // Después del alta, completar lo que haya quedado sin propiedad.
      if (esAlta && p && typeof p.then === 'function') {
        p.then(function (res) {
          if (res && res.ok) setTimeout(completarFaltantes, 0);
          return res;
        }).catch(function () {});
      }

      return p;
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', interceptar, { once: true });
  } else {
    interceptar();
  }
})();
